const state = {
  categoryLists: [],
  brandLists: [],
  documents: [],
  brands: [], // 选中的品牌信息
  total: 0,
  pageSize: 10,
  loading: false,
}
const getters = {
  getDocuments: (state) => {
    return state.documents
  },
  getCategoryLists: (state) => {
    return state.categoryLists
  },
  getBrandLists: (state) => {
    return state.brandLists
  },
  getTotal: (state) => {
    return state.total
  },
  getBrands: (state) => {
    return state.brands
  },
  getPageSize: (state) => {
    return state.pageSize
  },
  getLoading: (state) => {
    return state.loading
  },
}
const mutations = {
  setDocuments(state, data) {
    state.documents = data
  },
  setCategoryLists(state, data) {
    state.categoryLists = data
  },
  setBrandLists(state, data) {
    state.brandLists = data
  },
  setTotal(state, data) {
    state.total = data
  },
  setBrands(state, data) {
    state.brands = data
  },
  setLoading(state, data) {
    state.loading = data
  },
}

const actions = {
  // 获取手册查询列表
  async loadDocuments({ commit }, params) {
    try {
      commit('setLoading', true)
      const res = await this.$api.documents.getDocuments(params)
      if (res) {
        commit('setDocuments', res.documentLists)
        commit('setCategoryLists', res.categoryLists)
        commit('setBrandLists', res.brandLists)
        commit('setTotal', res.documentTotal)
      }
    } catch (error) {
      commit('setDocuments', [])
      commit('setCategoryLists', [])
      commit('setBrandLists', [])
      commit('setTotal', 0)
    } finally {
      commit('setLoading', false)
    }
  },
  // 获取选中品牌的信息
  async loadBrands({ commit }, params) {
    try {
      const res = await this.$api.documents.getBrands(params)
      if (res) {
        commit('setBrands', res)
      }
    } catch (error) {
      commit('setBrands', [])
    }
  }

}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
